import React from 'react';
import { number, bool, string, oneOfType } from 'prop-types';
import cn from 'clsx';
import LoadingIcon from '../../molecules/LoadingIcon/index.jsx';
import { imageSizes } from '../Image/sizes.js';
import Icon from '../Icon/index.jsx';
const getIconSize = (small, loading) => {
  if (loading) {
    return small ? 50 : 100;
  }
  return small ? 40 : 60;
};

/**
 * Placeholder component.
 */
var _ref = /*#__PURE__*/React.createElement(LoadingIcon, {
  className: "placeholder__loading-icon chromatic-ignore",
  color: "inherit",
  sizingUnit: "%",
  width: 100
});
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  className: "placeholder__icon",
  color: "inherit",
  name: "no-img",
  sizingUnit: "%",
  width: 100
});
const Placeholder = ({
  className,
  aspectRatio,
  small,
  loading,
  hideIcon
}) => /*#__PURE__*/React.createElement("div", {
  className: cn('placeholder', className)
}, /*#__PURE__*/React.createElement("div", {
  className: "placeholder__background",
  style: {
    paddingBottom: `${(imageSizes[aspectRatio] || aspectRatio) * 100}%`
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "placeholder__content",
  style: {
    width: getIconSize(small, loading)
  }
}, (() => {
  if (hideIcon) {
    return null;
  }
  if (loading) {
    return _ref;
  }
  return _ref2;
})()));
Placeholder.defaultProps = {
  className: null,
  small: false,
  loading: false,
  hideIcon: false
};
Placeholder.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The aspect ratio */
  aspectRatio: oneOfType([number, string]).isRequired,
  /** Allows a custom class to be added */
  className: string,
  /** Sets a smaller icon */
  small: bool,
  /** Render a loading spinner in place of the default icon. */
  loading: bool,
  /** Hide the placeholder icon. */
  hideIcon: bool
} : {};
export default Placeholder;